export default {
  path: 'forecast',
  name: 'Forecast',
  childRoutes: [],
};
